import { presetsUpdatePreset } from '../presets/actions';
import { propertiesUpdateProperty } from '../properties/actions';

export const globalMapUpdate = (action, dispatch) => {
  const parts = action.payload.key.split('.');
  const part = parts[0];
  const rest = parts.slice(1);

  if (part === 'properties') {
    dispatch(
      propertiesUpdateProperty({
        key: rest.join('.'),
        value: action.payload.value,
      })
    );
  }

  if (part === 'presets') {
    dispatch(
      presetsUpdatePreset({
        key: rest.join('.'),
        value: action.payload.value,
      })
    );
  }
};
